import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { useState, useEffect } from "react";
import { Loader } from "../Loader";
import ValidationMessage from "../ValidationMessage";
import { Para, ZipImage } from "./ZipCodeForm.styles";
import { useZipcodeAction } from "../../hooks/useZipcodeAction";
import { useCountryOption } from "../../hooks/useCountryOption";
import { getPostalCodeHint } from "../../services/utils";
import { POSTAL_CODE_INPUT_PROPS } from "../../services/form-fields";

export const ZipCodeForm = () => {
  const { funnel } = useSelector((state) => state.funnelInfo);
  const zipInfo = useSelector((state) => state.zipInfo);
  const textElements = funnel.textElements;
  const baseColor = funnel.design?.baseColor;
  const {
    mapImageSrc,
    handleUpdateZip,
    postalCodeLengths,
    isPostalCodeValid,
    handleCheckZipcode,
    handleZipcodeSubmit
  } = useZipcodeAction();
  // Loads the funnel country option once for this screen
  useCountryOption();
  const [isLoading, setIsLoading] = useState(true);
  const [showPostalCodeHint, setShowPostalCodeHint] = useState(false);

  const promise = new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, 2000);
  });
  const hideLoader = () => setIsLoading(false);
  const handleZipCodeSubmit = async () => {
    setIsLoading(true);

    await Promise.all([promise, handleCheckZipcode()]);

    hideLoader();
    handleZipcodeSubmit();
  };

  // A form, so Enter / the keyboard's "Weiter" key submits the postal code
  const onSubmit = (event) => {
    event.preventDefault();
    if (!isPostalCodeValid) {
      setShowPostalCodeHint(true);
      return;
    }
    handleZipCodeSubmit();
  };

  useEffect(() => {
    setTimeout(() => {
      hideLoader(false);
    }, 2000);
  }, []);

  return (
    <div className="px-3 pt-5 px-md-5">
      {isLoading && (
        <div className="text-center px-5 fs-5 fw-bolder">
          <div style={{ height: "200px", paddingTop: "40px" }}>
            <Loader scale={1.6} color={baseColor} />
          </div>
          <p>{textElements?.waitingScreen}</p>
        </div>
      )}
      {!isLoading && (
        <>
          <Para>{textElements?.zipCodeScreen}</Para>
          <div className="row align-items-center">
            <div className="col-12 col-md-4 text-center">
              <ZipImage src={mapImageSrc} alt="map" />
            </div>
            <Form className="col-12 col-md-8" noValidate onSubmit={onSubmit}>
              <Form.Control
                {...POSTAL_CODE_INPUT_PROPS}
                id="postalCode"
                enterKeyHint="next"
                maxLength={Math.max(...postalCodeLengths)}
                value={zipInfo.value}
                placeholder={"PLZ"}
                isInvalid={showPostalCodeHint}
                onChange={({ target: { value } }) => {
                  setShowPostalCodeHint(false);
                  handleUpdateZip({ value });
                }}
              />
              {showPostalCodeHint && (
                <ValidationMessage
                  message={getPostalCodeHint(postalCodeLengths)}
                />
              )}
              <Button
                type="submit"
                className="w-100 mt-2"
                disabled={!zipInfo.value}
              >
                {textElements?.zipCodeScreenButton} ▸
              </Button>
            </Form>
          </div>
        </>
      )}
    </div>
  );
};
